export const USER_ROLE_KEYS = {
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  DISPOSER: 'DISPOSER',
  AGENT: 'AGENT',
  VIEWER: 'VIEWER',
  DISPOSE: 'DISPOSER',
  C2B_OPS_FF_CHALLAN_ADMIN: 'ADMIN',
  C2B_OPS_FF_CHALLAN_VIEW: 'VIEWER',
  C2B_OPS_FF_CHALLAN_DISPOSE_VAS: 'C2B-OPS-FF-CHALLAN-DISPOSE-VAS',
} as const

export type UserRoleKey = (typeof USER_ROLE_KEYS)[keyof typeof USER_ROLE_KEYS]
